import { FORMS_SET } from "types/actions/forms"

export const saveFormData = (formName, data) => ({
  type: FORMS_SET,
  formName,
  data,
})
